module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kh-Ld.5dd03fa6.png";